import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card } from '../components/ui/card';

const TermsOfService = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#021F3F] via-[#0A3D62] to-[#021F3F]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t.terms.title}
          </h1>
          <p className="text-gray-300 text-lg">{t.terms.lastUpdated}</p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6" />
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-[#F8F8F8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {t.terms.sections.map((section, index) => (
            <Card key={index} className="p-8 mb-6 border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h2 className="text-2xl font-bold text-[#021F3F] mb-4">
                {section.title}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {section.content}
              </p>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;